import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    reportWrapper: {
        marginTop: 22,
    },
    header: {
        display: "flex",
        alignItems: "center",
        padding: "0px 22px",
    },
    reportSelectWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    headerActions: {
        display: "flex",
        gap: 16,
        color: theme.palette.info.main,
        fontFamily: "Open Sans",
        fontWeight: 700,
        fontSize: 12,
        textTransform: "uppercase",
    },
    alertInfo: {
        "&.MuiPaper-root .MuiAlert-message": {
            color: theme.palette.text.primary,
            fontFamily: "Open Sans",
            fontWeight: 500,
            fontSize: 14,
        },
        alignItems: "center",
    },
    headerActionWrapper: {
        display: "flex",
        alignItems: "center",
        gap: 6,
        cursor: "pointer",
        textDecorationLine: "underline",
    },
    downtimeSummaryWrapper: {
        height: 480,
        padding: 24,
        background: theme.palette.graphs.main,
    },
    headerActionsFullscreen: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        color: theme.palette.info.main,
        fontFamily: "Open Sans",
        fontWeight: 700,
        fontSize: 12,
        textTransform: "uppercase",
        width: "100%",
    },
    headerFilterButton: {
        "& button": {
            backgroundColor: theme.palette.primary.dark,
            border: "1px solid transparent !important",
            color: `${theme.palette.primary.main} !important`,
        },
        "& button:hover": {
            backgroundColor: theme.palette.primary.dark,
            border: "1px solid transparent !important",
            color: `${theme.palette.primary.main} !important`,
        },
        "& button.Mui-selected": {
            backgroundColor: theme.palette.info.main,
        },
        "& button.Mui-selected:hover": {
            backgroundColor: theme.palette.info.main,
        },
    },
    checkbox: {
        "&.MuiCheckbox-root": {
            color: theme.palette.info.main,
            "&.Mui-checked": {
                color: theme.palette.info.main,
            },
        },
        "&.MuiCheckbox-root .MuiSvgIcon-root": {
            width: "20px",
        },
    },
    checkboxLabel: {
        "&.MuiFormControlLabel-root .MuiTypography-root": {
            color: theme.palette.info.main,
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: 12,
            textDecorationLine: "underline",
            textTransform: "uppercase",
        },
    },
    inputLabel: {
        color: theme.palette.text.secondary,
        textAlign: "left",
    },
    select: {
        backgroundColor: theme.palette.secondary.main,
        width: "290px",
        height: "45px",
        borderRadius: "4px",
        boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
        marginBottom: "5px",
        fontFamily: "Open Sans !important",
    },
    menuItem: {
        fontFamily: "Open Sans !important",
    },
    dropdownBox: {
        display: "flex",
        gap: theme.spacing(4),
    },
    topHeaderArea: {
        flex: 1,
    },
    reportDateRangeWrapper: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    reportDisplayInWrapper: {
        paddingRight: theme.spacing(2),
    },
    reportDateRange: {
        "& > div:first-child": {
            color: theme.palette.text.secondary,
            fontFamily: "Open Sans",
            fontSize: 14,
            fontWeight: 700,
            lineHeight: 1.57,
            letterSpacing: "0.00714em",
            marginBottom: 0,
        },
        "& > div > .react-datepicker__input-container": {
            width: `250px !important`,
            marginBottom: "5px",
            "& > input": {
                backgroundColor: theme.palette.secondary.main,
                boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
                height: theme.spacing(11.25),
            },
        },
    },
    badge: {
        marginLeft: `${theme.spacing(4)} !important`,
    },
    badgeTitle: {
        marginLeft: `${theme.spacing(4)} !important`,
        marginTop: `-${theme.spacing(1)} !important`,
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Open Sans",
            paddingBottom: theme.spacing(0.625),
        },
    },
    warningIcon: {
        color: `${theme.palette.warning.main} !important`,
        width: "22px !important",
        height: "22px !important",
    },
}));
